"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ordinalSuffix = void 0;

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: =, Brian Bal
 */
var ordinalSuffix = function ordinalSuffix(num) {
  if (!num) {
    return "";
  }

  var suffix = "th";

  if (num > 10 && num < 20) {
    return suffix;
  }

  switch (num % 10) {
    case 1:
      suffix = "st";
      break;

    case 2:
      suffix = "nd";
      break;

    case 3:
      suffix = "rd";
      break;
  }

  return suffix;
};

exports.ordinalSuffix = ordinalSuffix;